import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";

import { Home } from "./pages/Home";
import { WhatWeDo } from "./pages/WhatWeDo";
import { Consulting } from "./pages/Consulting";
import { SoftwareDevelopment } from "./pages/SoftwareDevelopment";
import { Products } from "./pages/Products";
import { Labista } from "./pages/Labista";
import { Work } from "./pages/Work";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";

/**
 * Route changes must reset the scroll position, and a hash must win over
 * that reset. Browsers do this for real navigations; a client-side router
 * has to do it by hand, and skipping it is why SPA marketing sites so
 * often drop you halfway down the next page.
 */
function ScrollBehaviour() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, hash]);

  return null;
}

export function App() {
  return (
    <div className="relative isolate flex min-h-screen flex-col overflow-x-hidden">
      {/* Ambient ground. Fixed rather than per-section so the gradient does
       *  not restart at every section boundary. */}
      <div className="pointer-events-none fixed inset-0 -z-10 bg-grad-hero" />
      <div className="pointer-events-none fixed inset-0 -z-10 grid-bg opacity-[0.22]" />

      <ScrollBehaviour />
      <Nav />

      <main id="main" className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/software-development" element={<SoftwareDevelopment />} />
          <Route path="/products" element={<Products />} />
          <Route path="/labista" element={<Labista />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
